import { useSaveData } from '@entities/common/savedData/index.ts';

export const useExercisesListSavedData = () => {
  return useSaveData<{isOneVideoSelect:boolean}>('useExercisesListSavedData')
}